module.exports = __webpack_public_path__ + "img/logo.a9ecc1bc.png";